var zindexes = {
  menu: 888,
  focus: 9999
};

export { zindexes };
//# sourceMappingURL=zindexes.js.map
